import asset from './asset'
import assetValue from './assetValue'
import brand from './brand'
import brandNegotiate from './brandNegotiate'
import budget from './budget'
import build from './build'
import city from './city'
import design from './design'
import feasibility from './feasibility'
import group from './group'
import homeGroup from './homeGroup'
import homeHuamei from './homeHuamei'
import homePartners from './homePartners'
import homeHotel from './homeHotel'
import homeConsult from './homeConsult'
import humanResource from './humanResource'
import opening from './opening'
import operation from './operation'
import owner from './owner'
import performance from './performance'
import purchase from './purchase'
import hotel from './hotel'
import evaluationProspect from './evaluationProspect'
import empowerment from './empowerment'
import resources from './resources'
import mediation from './mediation'
import cityStrategy from './cityStrategy'
import groupStrategy from './groupStrategy'
import productBrandStrategy from './productBrandStrategy'
import hotelGroupTourismDestination from './hotelGroupTourismDestination'
import specialTown from './specialTown'
import happyIndustry from './happyIndustry'
import cityCentralActivityZone from './cityCentralActivityZone'
import industryWatch from './industryWatch'
import savings from './savings'
import nationalHotel from './nationalHotel'
import huamei from './huamei'
import constructionData from './constructionData'
import operationCase from './operationCase'
import smartTools from './smartTools'
import ecosystem from './ecosystem'
import assetAddValue from './assetAddValue'
import fiveStarHotel from './fiveStarHotel'
import funengShejicaigou from './funengShejicaigou'
import funengFanxieyexie from './funengFanxieyexie'
import annualSurvey from './annualSurvey'
import dataWang from './dataWang'
import huameiyun from './huameiyun'



import { formatURIComponent, extractFilePath } from "./utils"

const handlerMap = {
    "asset": asset,
    "assetValue": assetValue,
    "brand": brand,
    "brandNegotiate": brandNegotiate,
    "budget": budget,
    "build": build,
    "city": city,
    "design": design,
    "feasibility": feasibility,
    "group": group,
    "ownership_group": group,
    "management_group": group,
    "homeHotel": homeHotel,
    "homeGroup": homeGroup,
    "homeConsult": homeConsult,
    "homeHuamei": homeHuamei,
    "homePartners": homePartners,
    "hotel": hotel,
    "humanResource": humanResource,
    "opening": opening,
    "operation": operation,
    "owner": owner,
    "performance": performance,
    "purchase": purchase,
    "evaluationProspect": evaluationProspect,
    "empowerment": empowerment,
    "resources": resources,
    "mediation": mediation,
    "cityStrategy": cityStrategy,
    "groupStrategy": groupStrategy,
    "productBrandStrategy": productBrandStrategy,
    "hotelGroupTourismDestination": hotelGroupTourismDestination,
    "specialTown": specialTown,
    "happyIndustry": happyIndustry,
    "cityCentralActivityZone": cityCentralActivityZone,
    "industryWatch": industryWatch,
    "savings": savings,
    "nationalHotel": nationalHotel,
    "huamei": huamei,
    "constructionData": constructionData,
    "operationCase": operationCase,
    "smartTools": smartTools,
    "ecosystem": ecosystem,
    "assetAddValue": assetAddValue,
    "fiveStarHotel": fiveStarHotel,
    "funengShejicaigou": funengShejicaigou,
    "funengFanxieyexie": funengFanxieyexie,
    "annualSurvey": annualSurvey,
    "dataWang": dataWang,
    "huameiyun": huameiyun,
}

const getStartPageData = (category:string, instance:string) => {
    return handlerMap[category](instance)
}

const pathToRegexp = (path:string) => {
    return new RegExp("^" + path.replace(/%s/g, '[^\/]+') + ".*")
}

const overridePaths = [
    "四库赋能-酒店建设/品牌引进/优选资源/【隐藏】与众不同文件/",
    "四库赋能-酒店建设/设计管理/优选资源/【隐藏】与众不同文件/",
    "四库赋能-酒店建设/采购顾问/优选资源/【隐藏】与众不同文件/",
    "建设数据/分类汇总",
    "华美/华美简介/",
    "评估展望/品牌/品牌介绍/",
    "我的赋能链/公司介绍/",
    "评估展望/品牌",
    "评估展望/城市",
    "评估展望/集团",
    "评估展望/酒店",
    "行业观察",
    "优选资源",
    "项目",
    "我的",
    "华美",
]
const overrideRegex = [
    /四库赋能-酒店建设\/[^\/]+\//,
    /四库赋能-酒店资管\/[^\/]+\//,
    /四库赋能-酒店\+[^\/]+\//,
]

export const getAuthPath = (file_path:string) => {


    let targetPath = file_path.replace(/\/$/, '') + '/'
    targetPath = targetPath.replace(/^\//, '')
    targetPath = targetPath.replace(/^内容文件/, '')
    targetPath = targetPath.replace(/^\//, '')

    for (const path of overridePaths) {
        const pathRegex = pathToRegexp(path)
        if(pathRegex.test(targetPath)){
            return path
        }
        const pathRegex1 = pathToRegexp('/内容文件/' + path)
        if(pathRegex1.test(targetPath)){
            return path
        }
    }

    for (const regex of overrideRegex) {
        const match = targetPath.match(regex)
        if(match){
            console.log('【getAuthPath match】',
                match,
                match[0])
            return match[0]
        }
    }

    let iconFilePath = ""
    for (const key in handlerMap) {
        const handler = handlerMap[key]
        const configs = handler("%s")
        for (const config of configs) {
            if(!config.icons) continue
            for (const icon of config.icons) {
                if(!icon.url) continue
                iconFilePath = extractFilePath(icon.url)
                const iconFilePathRegex = pathToRegexp(iconFilePath)
                if(iconFilePathRegex.test(targetPath)){
                    return icon.path
                }
            }
        }
    }
    return "404"
}

export default getStartPageData